export default {
    CONTROL: "CONTROL",
    GROUP: "GROUP"
}
